const LISTING_SUMMARY_DISPLAY_STATUS = {
  DECLINED: 'declined',
  INACTIVE: 'inactive',
  PARTIALLY_PUBLISHED: 'partially published',
  PUBLISHED: 'published',
  PUBLISHING: 'publishing',
  WAITLISTED: 'waitlisted',
} as const;

const MULTIPLEX_OVERVIEW_DISPLAY_STATUS = {
  DRAFT: 'draft',
  PUBLISHED: 'published',
  NOT_STARTED: 'not started',
} as const;

export { LISTING_SUMMARY_DISPLAY_STATUS, MULTIPLEX_OVERVIEW_DISPLAY_STATUS };
